// src/components/Dashboard/MainDashboard.jsx
import CompanyAdminAndEmployeeDashboard from './CompanyAdminAndEmployee/CompanyAdminAndEmployeeDashboard';
import { Box } from '@chakra-ui/react';

const MainDashboard = () => {
	return (
		<Box>
			<CompanyAdminAndEmployeeDashboard />
		</Box>
	);
};

export default MainDashboard;
